<script>
import WhyXiyue from "@/components/WhyXiyue.vue";
import StartRisk from "@/components/StartRisk.vue";

export default {
  name: "CustomBoxes",
  components: {StartRisk, WhyXiyue}
}
</script>

<template>
  <div align="center">
    <div class="bg-light" style="padding-top: 50px;padding-bottom: 80px">
      <h1>Custom boxes for your needs</h1>
      <b-card-sub-title style="font-size: x-large; max-width: 80%">Precisely engineered in structure, style, and size to
        fit your product, protect your brand, and
        serve your purpose—from retail shelf to doorstep delivery.
      </b-card-sub-title>
      <div style="padding-top: 80px">

        <b-card class="overflow-hidden border-0 rounded-0 bg-light" style="max-width: 75%">

          <b-row no-gutters align-v="center">
            <b-col md="3">
              <b-card-img-lazy src="@/assets/6-1.jpg"></b-card-img-lazy>
            </b-col>
            <b-col md="9">
              <b-card-body style="margin-left: 20px">
                <h2>Luxury Gift Boxes</h2>
                <b-card-text class="text-left" style="font-size: x-large;padding-top: 20px">
                  Premium packaging for unforgettable unboxing. Made with high-end materials and finishes like foil
                  stamping
                  or embossing, they elevate brand perception for gifts, cosmetics, and high-value goods.
                </b-card-text>
              </b-card-body>
            </b-col>
          </b-row>
        </b-card>
      </div>
    </div>
    <b-card class="overflow-hidden border-0 rounded-0" style="padding-top: 80px;max-width: 75%;padding-bottom: 80px">
      <b-row no-gutters align-v="center">
        <b-col md="9">
          <b-card-body style="margin-right: 20px">
            <h2>Product Boxes</h2>
            <b-card-text class="text-left" style="font-size: x-large;padding-top: 20px">
              The primary packaging that holds, protects, and displays your product. Customized in size, print, and
              structure to represent your brand clearly on the shelf.
            </b-card-text>
          </b-card-body>
        </b-col>
        <b-col md="3">
          <b-card-img-lazy src="@/assets/6-2.jpg"></b-card-img-lazy>
        </b-col>
      </b-row>
    </b-card>
    <div class="bg-light">
      <b-card class="overflow-hidden border-0 rounded-0 bg-light"
              style="padding-top: 80px;max-width: 75%;padding-bottom: 80px">
        <b-row no-gutters align-v="center">
          <b-col md="3">
            <b-card-img-lazy src="@/assets/6-3.jpg"></b-card-img-lazy>
          </b-col>
          <b-col md="9">
            <b-card-body style="margin-left: 20px">
              <h2>Shipping Mailing Boxes</h2>
              <b-card-text class="text-left" style="font-size: x-large;padding-top: 20px">
                Durable, logistics-friendly boxes designed for safe and economical delivery. Lightweight yet strong,
                ideal
                for e-commerce and direct shipping.
              </b-card-text>
            </b-card-body>
          </b-col>
        </b-row>
      </b-card>
    </div>
    <b-card class="overflow-hidden border-0 rounded-0" style="padding-top: 80px;max-width: 75%;padding-bottom: 80px">
      <b-row no-gutters align-v="center">
        <b-col md="9">
          <b-card-body style="margin-right: 20px">
            <h2>Display Boxes</h2>
            <b-card-text class="text-left" style="font-size: x-large;padding-top: 20px">
              Eye-catching packaging that combines storage and presentation. Often feature windows or creative
              structures
              to highlight products directly at retail.
            </b-card-text>
          </b-card-body>
        </b-col>
        <b-col md="3">
          <b-card-img-lazy src="@/assets/6-4.jpg"></b-card-img-lazy>
        </b-col>
      </b-row>
    </b-card>

    <div class="bg-light" style="padding-top: 120px">
      <WhyXiyue></WhyXiyue>
    </div>
    <div style="padding-bottom: 80px;padding-top: 80px;max-width: 75%;">
      <StartRisk></StartRisk>
    </div>
  </div>
</template>

<style scoped lang="scss">

</style>